import {
  $getFiltersRequestType,
  $getPaginationResponseType,
  $NumberParam,
  $StringParam,
} from '@shared/types';
import { z } from 'zod';

export const $ReviewAnswer = z.object({
  id: z.number(),
  question: z.object({
    id: z.number(),
    code: z.string(),
    name: z.string(),
  }),
  answer: z.boolean(),
});

export type ReviewAnswer = z.infer<typeof $ReviewAnswer>;

export const $CompanyReview = z.object({
  id: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  isHired: z.boolean().nullable(),
  ratingTotal: z.number().nullable(),
  comment: z.string().nullable().optional(),
  reviewAt: z.string().nullable(),
  interviewDone: z.boolean().nullable().optional(),
  interviewCancellationReason: z.string().nullable().optional(),
  answers: z.array($ReviewAnswer).optional().default([]),
  company: z.object({
    id: z.number(),
    name: z.string(),
  }),
  vacancy: z.object({
    id: z.number(),
    name: z.string(),
  }),
  candidate: z
    .object({
      id: z.number(),
      firstname: z.string().nullable(),
      lastname: z.string().nullable(),
    })
    .optional(),
});

export type CompanyReview = z.infer<typeof $CompanyReview>;

export const $GetCompanyReviewsRequest = $getFiltersRequestType(
  z.object({
    companyId: $NumberParam,
    company: $StringParam,
    candidateFirstname: $StringParam,
    candidateLastname: $StringParam,
    vacancy: $StringParam,
    reviewAtFrom: z.string(),
    reviewAtTo: z.string(),
  })
);

export type GetCompanyReviewsRequest = z.infer<
  typeof $GetCompanyReviewsRequest
>;

export const $GetCompanyReviewsResponse =
  $getPaginationResponseType($CompanyReview);

export type GetCompanyReviewsResponse = z.infer<
  typeof $GetCompanyReviewsResponse
>;
